<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer003">
<p class="structure-next" id="calibre_pb_2"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"><span class="charoverride2">A Mother’s<br class="calibre1"/>Courage<br class="calibre1"/>to Awaken</span></p>
<p class="centered"><span class="character-bold1"> </span></p>
<p class="indent"><span class="character-bold1"> </span></p>
<div class="calibre2" id="calibre_pb_3"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_split_001.vue?3600e14c